import { render, staticRenderFns } from "@/templates/document/policyDocuments.html?vue&type=template&id=750e57dc&scoped=true&"
import script from "./PolicyDocuments.vue?vue&type=script&lang=js&"
export * from "./PolicyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./PolicyDocuments.vue?vue&type=style&index=0&id=750e57dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750e57dc",
  null
  
)

export default component.exports